export default "/dist/files/icon_menage_quotidien_gris.4c7578cc20795f4c3431a6c73d98997e.svg";